'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);
var _ramda = require('ramda');
var _reactRedux = require('react-redux');
var _reduxFormNormalizers = require('../../helpers/reduxFormNormalizers');
var _containers = require('../../containers');
var _SplitAutocomplete = require('./SplitAutocomplete.scss');var _SplitAutocomplete2 = _interopRequireDefault(_SplitAutocomplete);
var _searchAddressLocus = require('../../redux/modules/searchAddressLocus');
var _receiveSuggestions = require('../../redux/modules/receiveSuggestions');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

SplitAutocomplete = function (_Component) {_inherits(SplitAutocomplete, _Component);function SplitAutocomplete() {var _temp, _this, _ret;_classCallCheck(this, SplitAutocomplete);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      invalidAddress: false,
      focused: false }, _this.


    getErrorMessage = function () {
      if (!(0, _get2.default)(_this.props.value, 'city.address') || !(0, _get2.default)(_this.props.value, 'street.address')) {
        return _this.props.translate('fullAddressMessage');
      }
      return _this.props.translate('enterHouseNumber');
    }, _this.

    clearFields = function (name) {
      if (name === 'city') {
        _this.props.changeValue('address.street', {});
      }
      _this.props.changeValue('address.house', null);
    }, _this.

    handleBlur = function (event) {
      var inputName = event.target.name.split('.')[1];
      var fieldValue = (0, _get2.default)(_this.props.value, inputName);
      if ((0, _isEmpty2.default)(fieldValue)) {
        _this.setState({ invalidAddress: true });
      }
      _this.setState({ focused: false });

      _this.props.geocodeAddress(_this.props.value);
    }, _this.

    handleFocus = function (event) {var
      name = event.currentTarget.name;
      _this.setState({
        invalidAddress: false,
        focused: true });


      if (['address.street', 'address.house'].includes(name) && (0, _isEmpty2.default)((0, _get2.default)(_this.props.value, 'city'))) {
        document.getElementsByName('address.city')[0].focus();
      } else if (name === 'address.house' && (0, _isEmpty2.default)((0, _get2.default)(_this.props.value, 'street'))) {
        document.getElementsByName('address.street')[0].focus();
      }
    }, _this.

    createInputParameters = function (name) {return {
        name: name,
        suggestions: name === 'street' ? _this.props.streetSuggestions : _this.props.suggestions,
        className: (0, _classnames2.default)(_SplitAutocomplete2.default.inputWrapper, _SplitAutocomplete2.default[name]),
        locale: _this.props.locale,
        receiveSuggestions: name === 'street' ? _this.props.receiveStreetSuggestions : _this.props.receiveSuggestions,
        placeholder: _this.props.translate(name).toString(),
        changeValue: _this.props.changeValue,
        fieldValue: (0, _get2.default)(_this.props.value, name),
        requestString: function requestString(value) {return 'query=' + value + '&type=' + name + (name === 'street' ? '&tags[]=' + _this.props.value.city.key : '');},
        handleFocus: _this.handleFocus,
        clearFields: _this.clearFields,
        handleBlur: _this.handleBlur,
        params: Object.assign({
          type: name },
        name === 'street' && { tags: [(0, _get2.default)(_this.props.value, 'city.key')] }) };}, _this.



    keyPressHandler = function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        _this.props.createPin();
        _this.props.geocodeAddress(_this.props.value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);}SplitAutocomplete.prototype.

  render = function render() {var _cx;var _props =
    this.props,isRealtor = _props.isRealtor,translate = _props.translate,isMobile = _props.isMobile,isInvalid = _props.isInvalid;var _state =
    this.state,invalidAddress = _state.invalidAddress,focused = _state.focused;
    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(
          _SplitAutocomplete2.default.autocompleteWrapper,
          isRealtor && _SplitAutocomplete2.default.realtorAutocomplete,
          (invalidAddress || isInvalid) && !focused && _SplitAutocomplete2.default.invalidAddress) },


        _react2.default.createElement(_containers.PublishAutocompleteLocationInput,
        this.createInputParameters('city')),


        !isMobile && _react2.default.createElement('span', { className: _SplitAutocomplete2.default.delimiter }),

        _react2.default.createElement(_containers.PublishAutocompleteLocationInput,
        this.createInputParameters('street')),


        !isMobile && _react2.default.createElement('span', { className: _SplitAutocomplete2.default.delimiter }),

        _react2.default.createElement('div', { className: (0, _classnames2.default)(_SplitAutocomplete2.default.inputWrapper, _SplitAutocomplete2.default.house, (_cx = {}, _cx[_SplitAutocomplete2.default.invalidAddress] = this.props.geocodeFailed, _cx)) },
          _react2.default.createElement(_reduxForm.Field, {
            type: 'text',
            name: 'address.house',
            component: 'input',
            placeholder: translate('house'),
            normalize: _reduxFormNormalizers.maxThreeDigit,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onKeyPress: this.keyPressHandler })),



        (invalidAddress || isInvalid) && !focused &&
        _react2.default.createElement('div', { className: _SplitAutocomplete2.default.errorMessage },
          this.getErrorMessage())));




  };return SplitAutocomplete;}(_react.Component);


SplitAutocomplete.propTypes = {
  isRealtor: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  changeValue: _propTypes2.default.func,
  value: _propTypes2.default.object,
  suggestions: _propTypes2.default.array,
  streetSuggestions: _propTypes2.default.array,
  route: _propTypes2.default.any,
  receiveSuggestions: _propTypes2.default.func,
  receiveStreetSuggestions: _propTypes2.default.func,
  geocodeAddress: _propTypes2.default.func,
  params: _propTypes2.default.object,
  address: _propTypes2.default.array,
  searchAddress: _propTypes2.default.func,
  createPin: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isInvalid: _propTypes2.default.bool,
  geocodeFailed: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    suggestions: state.suggestions.suggestions,
    streetSuggestions: state.suggestions.streetSuggestions,
    address: state.searchAddressLocus.address };};


var mapDispatchToProps = {
  receiveSuggestions: _receiveSuggestions.receiveSuggestions,
  receiveStreetSuggestions: _receiveSuggestions.receiveStreetSuggestions,
  searchAddress: _searchAddressLocus.searchAddress };exports.default =


(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(
SplitAutocomplete);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SplitAutocomplete/SplitAutocomplete.js
// module id = 2886
// module chunks = 0